import React, { useState, useEffect } from 'react';
import { Plus, UserCheck, UserX } from 'lucide-react';
import { toast } from 'react-toastify';
import StudentList from '../components/students/StudentList';
import { studentsApi } from '../services/api';
import { Student } from '../types';

const Students: React.FC = () => {
  const [students, setStudents] = useState<Student[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStudents();
  }, []);

  const loadStudents = async () => {
    try {
      setLoading(true);
      const data = await studentsApi.getAll();
      setStudents(data);
    } catch (error) {
      toast.error('Failed to load students');
      console.error('Error loading students:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[#f3ede2]">Student Management</h1>
          <p className="text-[#b9ad9b] mt-1">Manage student registrations and admissions</p>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-[#211c15] rounded-lg border border-[#3a3122] p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[#b9ad9b] text-sm font-medium">Total Students</p>
              <p className="text-2xl font-bold text-[#f3ede2] mt-2">{students.length}</p>
            </div>
            <div className="w-12 h-12 bg-[#16212b] rounded-lg flex items-center justify-center">
              <Plus className="w-6 h-6 text-[#60a5fa]" />
            </div>
          </div>
        </div>

        <div className="bg-[#211c15] rounded-lg border border-[#3a3122] p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[#b9ad9b] text-sm font-medium">Pending Admissions</p>
              <p className="text-2xl font-bold text-[#f3ede2] mt-2">
                {students.filter(s => s.admissionStatus === 'Submitted').length}
              </p>
            </div>
            <div className="w-12 h-12 bg-[#332711] rounded-lg flex items-center justify-center">
              <UserCheck className="w-6 h-6 text-[#f0b64c]" />
            </div>
          </div>
        </div>

        <div className="bg-[#211c15] rounded-lg border border-[#3a3122] p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[#b9ad9b] text-sm font-medium">Approved Students</p>
              <p className="text-2xl font-bold text-[#f3ede2] mt-2">
                {students.filter(s => s.admissionStatus === 'Approved').length}
              </p>
            </div>
            <div className="w-12 h-12 bg-[#173322] rounded-lg flex items-center justify-center">
              <UserX className="w-6 h-6 text-[#4ade80]" />
            </div>
          </div>
        </div>
      </div>

      {/* Students List */}
      <StudentList students={students} loading={loading} />
    </div>
  );
};

export default Students;
